// extracted by mini-css-extract-plugin
module.exports =  {"chips":"_0d624b9a27--chips--bv95w"};